import React from "react";
import MarkdownDocPage from "@/components/MarkdownDocPage";
import { Handshake, ShieldCheck, Rocket, Users } from "lucide-react";

const STATS = [
  { icon: Rocket, label: "Positioning", value: "AI-native newco" },
  { icon: ShieldCheck, label: "Risk transfer", value: "Escrow + SLAs" },
  { icon: Users, label: "Staffing", value: "0 → on award" },
  { icon: Handshake, label: "Entry", value: "Paid pilot" },
];

export default function TrilliumApproach() {
  return (
    <MarkdownDocPage
      title="Winning Trillium as a New Company"
      subtitle="The credibility & go-to-market approach — how a brand-new, AI-native company proves it can pull this off."
      mdUrl="/docs/GoMCO-Trillium-Approach.md"
      pdfKey="trillium-approach"
      pdfName="GoMCO-Trillium-Approach.pdf"
      stats={STATS}
      testid="approach-content"
    />
  );
}
